import script from "./BotLandingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BotLandingPage.vue?vue&type=script&setup=true&lang=js"

import "./BotLandingPage.vue?vue&type=style&index=0&id=420859f5&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-420859f5"]])

export default __exports__